import { Storage } from '@splotch/core-ui';
import { useCallback, useContext, useState } from 'react';
import type { Spectrum1D } from '../../model';
import { Context } from './context';

interface Response {
  addSpectra: (_spectra: Spectrum1D.Datum[]) => void;
  loading: boolean;
  error?: Error;
}

export namespace UseAddSpectra {
  export const useAddSpectra = (): Response => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error>();
    const { datumKey, setDatum } = useContext(Context);

    const addSpectra = useCallback(
      (spectra: Spectrum1D.Datum[]) => {
        setLoading(true);
        // const spectra = [];

        try {
          setDatum!(spectra[0]);
          try {
            Storage.setItem(datumKey!, JSON.stringify(spectra[0], Storage.replacer));
          } catch {
            // @fixme: Do something in the event this error occurs - browser was unable to store the info
          }
        } catch (_error: unknown) {
          setError(<Error>_error);
        }
        setLoading(false);

        // return spectra;
      },
      [datumKey, setDatum]
    );

    return {
      addSpectra,
      error,
      loading
    };
  };
}
